<p class="order-financial-total">Total: ${{total() | number:'1.2-2'}}</p>
